'use client';
import Link from 'next/link';
import {useAppearance} from '@/app/context/AppearanceContext';

// Connected-M mark on a slate tile. The badge spins on hover (see globals.css).
export default function BrandLogo() {
  const {name}=useAppearance();
  return (
    <Link
      href="/"
      className="logo-wrapper flex flex-col items-center gap-1 sm:flex-row sm:gap-3 no-underline"
    >
      <div className="logo-badge w-9 h-9 sm:w-10 sm:h-10 p-[3px] flex items-center justify-center shrink-0">
        <svg viewBox="75 70 310 330" aria-hidden="true">
          <defs>
            <linearGradient id="marothOrange" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#FF5722" />
              <stop offset="100%" stopColor="#FF9800" />
            </linearGradient>
          </defs>
          <path
            d="M 120 360 L 120 220 A 55 55 0 0 1 230 220 L 230 300 A 55 55 0 0 1 340 220 L 340 360"
            fill="none"
            stroke="url(#marothOrange)"
            strokeWidth="48"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="175" cy="115" r="27" fill="url(#marothOrange)" />
          <circle cx="285" cy="115" r="27" fill="url(#marothOrange)" />
        </svg>
      </div>
      {/* Stacked and tiny on mobile - the header is icon-first there; back to
          the regular side-by-side wordmark from the sm breakpoint up. */}
      <span className="font-[family-name:var(--font-heading)] font-black text-[9px] sm:text-[1.4rem] tracking-[-0.01em] sm:tracking-[-0.03em] text-[var(--text-main)] leading-none whitespace-nowrap">
        {name}
      </span>
    </Link>
  );
}
